
//  If hour is provided then we filter by hour, otherwise we take all
export const courseIsDuringHour = (hourId) => (course = {}) => hourId ? course?.hourId === hourId : true;